export const NotFoundImg = () => (
  <svg width="47" height="41" viewBox="0 0 47 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5 1.5C19.4624 1.5 17 3.96243 17 7C17 10.0376 19.4624 12.5 22.5 12.5C24.019 12.5 25.393 11.8852 26.3891 10.8891C27.3852 9.89296 28 8.51899 28 7C28 3.96243 25.5376 1.5 22.5 1.5ZM15.5 7C15.5 3.13401 18.634 0 22.5 0C26.366 0 29.5 3.13401 29.5 7C29.5 8.66252 28.9197 10.1906 27.9517 11.3911L31.2803 14.7197C31.5732 15.0126 31.5732 15.4874 31.2803 15.7803C30.9874 16.0732 30.5126 16.0732 30.2197 15.7803L26.8911 12.4517C25.6906 13.4197 24.1625 14 22.5 14C18.634 14 15.5 10.866 15.5 7Z"
      fill="#D1D5DB"
    />
    <rect y="33" width="35" height="8" rx="4" fill="#D1D5DB" />
    <rect x="28" y="23" width="19" height="8" rx="4" fill="#E2E8F0" />
  </svg>
);
